import { render } from "./Main.vue?vue&type=template&id=763ce8ff"
const script = {}
script.render = render

export default script